const firebaseConfig = {
    apiKey: "AIzaSyDgtv9XA9IULTqp5hhEXj6Ab57PcDAKwDY",
    authDomain: "artisan-travel-agency.firebaseapp.com",
    projectId: "artisan-travel-agency",
    storageBucket: "artisan-travel-agency.appspot.com",
    messagingSenderId: "86215776194",
    appId: "1:86215776194:web:af45a9f8e978e14658285b"
  };

  export default firebaseConfig;